// extracted by mini-css-extract-plugin
module.exports = {"goBack":"AdacHistoryPage_goBack__URsR5"};